import React from 'react';
import { ImportSource } from '../../graphql/generated/graphql';
import ImportFileModal from './ImportFileModal';
import Link from '../../utils/router/Link';

interface GuruImportModalProps {
  close: () => void;
}

const ACCEPT = { 'text/csv': [] };

const GuruImportModal = ({ close }: GuruImportModalProps) => (
  <ImportFileModal
    close={close}
    source={ImportSource.Guru}
    uploaderSubject="the CSV file from Guru's Card Manager export"
    accept={ACCEPT}
    footer={
      <Link
        to="https://go.slab.com/guru-how-to-export-guru-cards"
        rel="noopener noreferrer"
        target="_blank"
      >
        How do I get CSV export from Guru?
      </Link>
    }
  />
);

export default GuruImportModal;
